<footer class="page-footer">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-12">
        <div class="footer-content d-flex align-items-center justify-content-between flex-nowrap gap-1 gap-sm-2 w-100">
          <p
            class="mb-0 text-muted small footer-copyright min-w-0 flex-grow-1 text-truncate"
            [attr.title]="'© ' + currentYear + ' ameconvienefinance srl - Tutti i diritti riservati.'"
          >
            &copy; {{ currentYear }} ameconvienefinance srl - Tutti i diritti riservati.
          </p>
          <p class="mb-0 text-muted small footer-version flex-shrink-0">v{{ version }}</p>
        </div>
      </div>
    </div>
  </div>
</footer>
